import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import {getArrayRandValue, getRandomInt} from "../../framework/src/helpers";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolGold(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    /** @type {MadnesObject|null} */
    this._winShineObject;
    /** @type {MadnesObject|null} */
    this._sparkle;
    /** @type {MadnesTween|null} */
    this._standTweenScale;
    /** @type {Function|null} */
    this._winAnimResolver;

    this._sparklePositions = [
        { 'x': 78, 'y': 36 },
        { 'x': 160, 'y': 155 },
        { 'x': 148, 'y': 60 },
        { 'x': 55, 'y': 47 },
        { 'x': 92, 'y': 73 },
        { 'x': 127, 'y': 155 },
        { 'x': 188, 'y': 142 },
        { 'x': 142, 'y': 102 },
    ];
};

SymbolGold.prototype = Object.create(AbstractSymbol.prototype);
SymbolGold.prototype.constructor = SymbolGold;

SymbolGold.shineColor = 0xf8c100;

/**
 * @returns {number}
 */
SymbolGold.prototype.getShineColor = function() {
    return SymbolGold.shineColor;
};

SymbolGold.prototype.clear = function() {

    //this.parentSprite.setTexture(null);
    this._clearParentSprite();

    this.shineSymbol = null;
    this.destroyShineAnim();

    this.removeChilds();
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolGold.prototype.createSymbol = function() {
    this.clear();
    this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName);

    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */

SymbolGold.prototype.createSimpleSymbol = function() {
    return this.createSymbol();
};

SymbolGold.prototype._createSparkle = function() {
    this._sparkle = this.createImage(0, 0, "symbols_atlas").setFrameName("spark_gold").setVisible(false).setBlend("ADD");
};

SymbolGold.prototype.createStandAnim = function() {
    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this.symbolName + "_shine").setBlend("ADD");  //.setScale(1.5, 1.5)
    this.createShineAnim();

    this._createSparkle();
};

SymbolGold.prototype.playStandAnim = function() {
    this._standAnimLoop();
};

SymbolGold.prototype._standAnimLoop = function() {

    if(!AbstractSymbol.spriteExists(this._sparkle)) return;

    var delay = getRandomInt(500, 1000);
    var duration = getRandomInt(1000, 2000);

    var pos = AbstractSymbol.getRealPosition(getArrayRandValue(this._sparklePositions));

    this._sparkle.setPos(pos['x'], pos['y']);
    this._sparkle.setScale(0, 0);
    this._sparkle.setVisible(true);
    this._standTweenScale = MI.addTween();
    this._standTweenScale.to(this._sparkle, { 'x': 1, 'y': 1 }, {
        'scale': true,
        'delay': delay,
        'duration': duration / 2,
        'easing': this._standTweenScale.getEasing("quadratic_out"),
        'callback': function() {

            if(!AbstractSymbol.spriteExists(this._sparkle) || !this._standTweenScale) return;

            this._standTweenScale.to(this._sparkle, { 'x': 0, 'y': 0 }, {
                'scale': true,
                'duration': duration / 2,
                'easing': this._standTweenScale.getEasing("quadratic_in"),
                'callback': function() {
                    this._standAnimLoop();
                }.bind(this)
            });
        }.bind(this)
    });
};

SymbolGold.prototype.stopStandAnim = function() {
    this._standTweenScale && this._standTweenScale.stop();
};

SymbolGold.prototype.fadeOutStandAnim = function() {
    var _self = this;

    MI.addTween().to(this._sparkle, { 'alpha': 0 }, {
        'duration': 200,
        'callback': function() {
            _self.stopStandAnim();
            _self._sparkle.destroy();
        }
    });
};

SymbolGold.prototype.fadeInStandAnim = function() {
    this._createSparkle();
    this.playStandAnim();
};

/**
 * @returns {SymbolGold}
 */
SymbolGold.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(0, 0, "symbol_Gold_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineObject.createAnims();
    this._winShineObject.anims.add("shine", MI.generateFrameNames("symbol_Gold_", 0, 19, "", 5));

    this._winShineObject.anims.addOnComplete(function() {

        /*MI.addTween().to(this._winShineObject, { 'alpha': 0 }, {
            'duration': 300,
            'callback': function() {
                this._winShineObject.destroy();*/
        this._winAnimResolver();
        /*}.bind(this)
    });*/

    }.bind(this));

    return this;
};

SymbolGold.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};

/**
 * @returns {Promise}
 */
SymbolGold.prototype.playWinAnim = function() {

    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("shine");

    }.bind(this));
};

SymbolGold.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};